// Portal bearer-token storage (VII-207).
//
// Separate from the main app's Firebase auth so the two never collide. The
// portal user is an external customer (not a Viilu tenant member), so we
// can't reuse `useAuth()` from the main app — we manage our own session.

const BEARER_KEY = 'viilu_portal_bearer';
const EMAIL_KEY = 'viilu_portal_email';

export function getPortalBearer() {
  try {
    return window.localStorage.getItem(BEARER_KEY) || null;
  } catch {
    return null;
  }
}

export function setPortalBearer(bearer, email) {
  try {
    window.localStorage.setItem(BEARER_KEY, bearer);
    if (email) window.localStorage.setItem(EMAIL_KEY, email);
  } catch {
    // localStorage disabled — caller should treat the session as ephemeral.
  }
}

export function getPortalEmail() {
  try {
    return window.localStorage.getItem(EMAIL_KEY) || null;
  } catch {
    return null;
  }
}

export function clearPortalSession() {
  try {
    window.localStorage.removeItem(BEARER_KEY);
    window.localStorage.removeItem(EMAIL_KEY);
  } catch {
    // ignore
  }
}
